var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.product)?_c('div',[_c('Product',{attrs:{"product":_vm.product,"package-items":_vm.packageItems,"package-upgrades":_vm.packageUpgrades,"package-editions":_vm.packageEditions}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }